module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-scrollbar', {
    ref: "scrollContainer",
    staticClass: "scroll-container",
    attrs: {
      "vertical": false
    },
    nativeOn: {
      "wheel": function($event) {
        $event.preventDefault();
        return _vm.handleScroll.apply(null, arguments)
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-48cdd0e6"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tagsView/ScrollPane.vue
// module id = 1913
// module chunks = 1